// extracted by mini-css-extract-plugin
export default {"cardHeaderIcon":"c-e_cK","cardHeaderIcon__content":"c-e_cL"};